module.exports = __webpack_public_path__ + "img/4.db695f43.png";